#### Extended location hierarchy for Asia

We’ve extended our location hierarchy and [location suggest] with increased granularity in the following regions where the SEEK Group operates:

| Code | Name            |
| :--: | :-------------- |
|  HK  | Hong Kong       |
|  ID  | Indonesia       |
|  MY  | Malaysia        |
|  PH  | The Philippines |
|  SG  | Singapore       |
|  TH  | Thailand        |

The hierarchy only extends to the country level (e.g. Fiji) outside of our core Asia-Pacific locations.

This enhances efficiency and accuracy when posting and searching for international jobs on the SEEK Australia & New Zealand marketplace,
and lays the groundwork for the SEEK API to support Jobstreet & Jobsdb markets in future.

For the time being, job ads posted to deprecated locations will be mapped to the corresponding new locations and will continue to function as expected across the SEEK API.
If you’re using the [`locationSuggestions` query], you will automatically receive our new locations and will not have to modify your integration.
If you’re caching locations or using a static mapping to [map from your internal location hierarchy],
we will contact you at a future date to refresh your data before we remove support for deprecated locations.

[location suggest]: /use-cases/job-posting/locations#option-1-build-a-seek-specific-location-input
[`locationsuggestions` query]: /schema/query/locationSuggestions
[map from your internal location hierarchy]: /use-cases/job-posting/locations#option-2-map-from-your-internal-location-hierarchy
